import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";

class Delete_record_audit extends PureComponent {
  render() {
    return (
      <div className="row" id="delete_record_audit">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Delete Record Audit</h2>
              <p>
                All record events are audited for a minimum of 45 days. If they
                are not cleared audit records will be kept indefinitely. This
                function allows you to delete audit logs of a specified data
                type. Once deleted they cannot be recovered.
              </p>
              <p>
                To delete audit records you must have the”AUDITCLEAN” or “ADMIN”
                permission.
              </p>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>Delete Record Audit Example</h2>
              <p>
                In this example will delete audit records older than 60 days.
              </p>
              <p>Request:</p>
              <div className="darkCode">
                <span className="methodCodeDELETE">DELETE</span> - https://
                <span className="jsonY">example</span>.api.nexoid.com/v1/record/
                <span className="jsonY">object_type</span>
                /audit
                <div>
                  <br />
                </div>
                <div>Body:</div>
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"session_id"</span>:{" "}
                  <span className="jsonY">
                    "
                    <span className="jsonO">
                      &#123;&#123;session_id&#125;&#125;
                    </span>
                    "
                  </span>
                  ,
                </div>
                <div className="i1">
                  <span className="jsonG">"age"</span>:{" "}
                  <span className="jsonP">60</span>
                </div>
                <div>&#125;</div>
              </div>
              <p>Response:</p>
              <div className="darkCode">
                <div>
                  Code: <span className="statusCode">200</span>
                </div>
                <div>
                  <br />
                </div>
                <div>Body:</div>
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"deleted"</span>:{" "}
                  <span className="jsonP">25164</span>
                </div>
                <div>&#125;</div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default Delete_record_audit;



// WEBPACK FOOTER //
// ./src/components/knowlege/api/Delete_record_audit.js